module.exports = __webpack_public_path__ + "img/sad.7d1ecb73.png";